var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"open-on-hover":"","nudge-right":"30","nudge-down":"30"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g(_vm._b({class:_vm.classes},'v-icon',_vm.$attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},[_c('v-card',[_c('v-card-text',{staticStyle:{"max-width":"400px"},domProps:{"innerHTML":_vm._s(_vm.helpText)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }